import { notification } from "/shared/utils.js";
import { initComponentById, initComponentsByClassName } from "/shared/svelte.js";
import ItemsGallery from "/inventory/ItemsGallery.svelte";
import CheckoutProductsGallery from "/inventory/CheckoutProductsGallery.svelte";
import BookItemModal from "/inventory/BookItemModal.svelte";
import BusinessUpdatesCard from "/blog/components/BusinessUpdatesCard.svelte";
import NearbyBusinesses from "./NearbyBusinesses.svelte";
import FloatingButtonsFooter from "../enquiry/FloatingButtonsFooter.svelte";
import ThirtyWords from "/traveller/modals/ThirtyWords.svelte";

import ProfileMap from "../maps/ProfileMap.svelte";
import CovidResponseCard from "./CovidResponseCard.svelte";
import TravellerRecommendations from "./TravellerRecommendations.svelte";
import FooterAreaList from "./FooterAreaList.svelte";
import BusinessProfileExplore from "./BusinessProfileExplore.svelte";
import ClaimListing from "./ClaimListing.svelte";

import "jquery-plainmodal";
import "/initSwiper";
import "/datepicker.js";
import "../../../css/datepicker.css";

/*
 * claim your listing card for unclaimed businesses
 */
initComponentById("claimYourListing", ClaimListing);

/*
 * thiry words section
 */
initComponentById("thirtyWordsSection", ThirtyWords);
/*
 * item cards (rooms, activities, dishes, products)
 */
initComponentById("activityGallery", ItemsGallery, {
  businessCode: window.businessCode,
  itemType: "activity",
});

initComponentById("roomGallery", ItemsGallery, {
  businessCode: window.businessCode,
  itemType: "room",
});

initComponentsByClassName(".checkoutProductGallery", CheckoutProductsGallery, {
  businessCode: window.businessCode,
});

initComponentById("dishGallery", ItemsGallery, {
  businessCode: window.businessCode,
  itemType: "dish",
});

initComponentById("bookItemModal", BookItemModal);

/*
 * map
 */
initComponentById("detailMapWrapper", ProfileMap);

/*
 * posts card
 */
initComponentById("posts", BusinessUpdatesCard, {
  businessCode: window.businessCode,
});

/*
 * Covid response card
 */
initComponentById("covidResponseCard", CovidResponseCard);

initComponentsByClassName(".explore-area", BusinessProfileExplore);
initComponentsByClassName(".list-nearby-areas", FooterAreaList);
initComponentsByClassName(".floatingButtons", FloatingButtonsFooter);
initComponentById("nearbyBusinesses", NearbyBusinesses);
initComponentById("highlights", TravellerRecommendations);

/*
 * Handlers
 */

$(".ajax-email").click((ev) => {
  const url = `/email/${window.businessCode}`;
  $.get(url, (response) => {
    window.location.href = `mailto:${response.email_address}`;
  }).fail(() => {
    $("#mailto-failure-modal").plainModal("open");
  });
});

/*
 * guest question form submit handler
 */
$("#guestQuestionForm").submit(function (e) {
  e.preventDefault();
  let form = $(this);

  $.ajax({
    type: "POST",
    url: form.attr("action"),
    data: form.serialize(),
    success: function () {
      form.trigger("reset");
      $("#guestQuestionModal").modal("hide");
      $(".booking-footer").show();
      // Display a success notification
      notification.success("Question has been sent!");
    },
  });
});
